import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ChatSidebarComponent } from "src/app/chat/components/chat-sidebar/chat-sidebar.component";
import { ChatComponent } from 'src/app/chat/components/chat/chat.component';
import { PrimeNgModule } from "../prime-ng/prime-ng.module";
import { FormsModule } from '@angular/forms';


// Http Loader for ngx-translate
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    ChatSidebarComponent,
    ChatComponent,
  ],
  imports: [
    PrimeNgModule,
    CommonModule,
    NgbModule,
    FormsModule,
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: createTranslateLoader
      }
    }),

  ],
  exports: [ChatSidebarComponent,ChatComponent]
})

export class ChatModule { }